import { Body, Box } from '@hover/blueprint';
import React from 'react';
import { animated, config, useTransition } from 'react-spring';

import { Hr, Link } from 'src/shared/components';
import { useSingleSignOn, useTranslate } from 'src/shared/hooks';
import { TwoColumn } from 'src/shared/layouts';
import { Route } from 'src/shared/route';
import { loginSsoStarted, loginStarted } from 'src/shared/telemetry';

const AnimatedLink = animated(Link);

const Footer = () => {
  const t = useTranslate('login');
  const { isActive: isSingleSignOnActive } = useSingleSignOn();
  const transitions = useTransition(isSingleSignOnActive, null, {
    config: config.stiff,
    enter: { opacity: 1 },
    leave: { opacity: 0, position: 'absolute' },
  });

  return (
    <TwoColumn.Footer>
      <Box
        alignItems="center"
        alignSelf="stretch"
        display="grid"
        gridAutoFlow="column"
        gridGap={200}
        justifyContent="center"
      >
        <Body marginBottom={0} marginTop={0} size={500}>
          {t('notRegisteredYet')}
        </Body>
        <Link preserveQuery testId="signup-link" to={Route.SIGN_UP.path}>
          {t('signUp')}
        </Link>
      </Box>
      <Box
        alignItems="center"
        alignSelf="stretch"
        display="grid"
        gridAutoFlow="column"
        gridGap={200}
        gridTemplateColumns="1fr auto 1fr"
        justifyContent="center"
      >
        <Hr />
        <Body color="neutral500" size={400}>
          {t('or')}
        </Body>
        <Hr />
      </Box>
      <Box alignContent="center" alignItems="center" flexDirection="column">
        {transitions.map(({ item, key, props: style }) =>
          item ? (
            <AnimatedLink
              key={key}
              preserveQuery
              style={style}
              testId="login-password-link"
              to={Route.LOGIN.path}
              track={loginStarted}
            >
              {t('singleSignOn.logInWithPassword')}
            </AnimatedLink>
          ) : (
            <AnimatedLink
              key={key}
              preserveQuery
              style={style}
              testId="login-sso-link"
              to={Route.LOGIN_SSO.path}
              track={loginSsoStarted}
            >
              {t('logInWithSingleSignOn')}
            </AnimatedLink>
          ),
        )}
      </Box>
    </TwoColumn.Footer>
  );
};

export { Footer };
